<div class="row justify-content-center">
    <div class="col-auto">
        <div class="alert alert-warning text-center" role="alert">
            <h4 class="alert-heading">Demo account</h4>
            <p>This account is an demo account and this order will therefore not be processed</p>
            <hr>
            <p class="mb-0">Thank you for use the demo</p>
        </div>
    </div>
</div>